import {jsx} from 'panel';

import {ButtonTheme} from 'common/components/button/constants';
import {InputEl} from 'common/components/input';
import {SvgIconEl} from 'common/components/svg-icon';
import {KEY_VALUES} from 'common/util/dom';
import {ControlBarEl} from 'common/widgets/control-bar';
import {MetricType} from 'common/query-builder/query-block/constants';

import {ControlBarAction, ControlBarActionItems} from '../constants';
import {Action, EntryPart, MetricEntry} from '../types';
import type {QueryEntrySection} from '../index';

const MetricTypeIconMap: {[key in MetricType]: string} = {
  [MetricType.Event]: `brand-insights`,
  [MetricType.CustomEvent]: `brand-insights`,
  [MetricType.Funnel]: `brand-funnels`,
  [MetricType.Retention]: `brand-retention`,
  [MetricType.People]: `brand-insights`,
  [MetricType.Cohort]: `brand-insights`,
  [MetricType.Formula]: `formula-scroll`,
};

export function MetricHeader({el, entry, index}: {el: QueryEntrySection; entry: MetricEntry; index: number}) {
  const {isExpanded} = entry;
  const {index: activeIndex, part: activePart} = el.state.openEntry;

  return (
    <div sel='.mp-metric-entry-header'>
      <SvgIconEl sel='.mp-metric-entry-header-icon' attrs={{icon: MetricTypeIconMap[entry.behavior.type]}} />
      {activePart === EntryPart.MetricName && activeIndex === index ? (
        <InputEl
          sel='.mp-metric-entry-header-input'
          attrs={{
            'select-on-focus': true,
          }}
          props={{
            value: entry.behavior.name || `Untitled`,
          }}
          on={{
            blur: (ev) => el.handleMetricNameChange(index, ev.target.value),
            keydown: (ev: any) => {
              if (ev.key === KEY_VALUES.ESCAPE) {
                ev.preventDefault();
                el.setActiveEntry({index: null, part: null});
              } else if (ev.key === KEY_VALUES.ENTER) {
                ev.preventDefault();
                el.handleMetricNameChange(index, ev.target.value);
              }
            },
          }}
          hook={{
            insert: (vnode: any) => {
              requestAnimationFrame(() => {
                vnode.elm.focus();
              });
            },
          }}
        />
      ) : (
        <div
          sel='.mp-metric-entry-header-name'
          on={{
            click: () => el.update({openEntry: {index, part: EntryPart.MetricName}}),
          }}
        >
          {entry.behavior.name || `Untitled`}
        </div>
      )}
      <div sel='.mp-metric-entry-header-actions'>
        <SvgIconEl
          sel='.expand-control'
          attrs={{icon: isExpanded ? `collapse-diagonal` : `expand`}}
          on={{
            click: () => el.handleMetricExpand(index, isExpanded ? `collapse` : `expand`),
          }}
        />
        <ControlBarEl
          attrs={{
            elref: `metricRowControlBar`,
            theme: ButtonTheme.Tertiary,
            'overflow-controls': [
              {
                items: [
                  ControlBarActionItems[ControlBarAction.Duplicate],
                  ControlBarActionItems[ControlBarAction.Delete],
                ],
              },
            ],
          }}
          on={{
            select: (ev: CustomEvent<{value: {action: ControlBarAction}}>) => {
              switch (ev.detail.value.action) {
                case ControlBarAction.Duplicate:
                  el.helpers.onEventActionClick(Action.Clone, index);
                  break;
                case ControlBarAction.Delete:
                  el.helpers.onEventActionClick(Action.Remove, index);
                  break;
              }
            },
          }}
        />
      </div>
    </div>
  );
}
